var map = {
	"./8.jpg": 63225,
	"./FLR.jpg": 9681,
	"./fish 3.jpg": 89232,
	"./flowers 01.jpg": 36368,
	"./flowers 1.jpg": 26228,
	"./flowers 2.jpg": 11683,
	"./flr 1.jpg": 39604,
	"./girl 2.jpg": 84101,
	"./girl 3.jpg": 56936,
	"./girl 4.jpg": 86939,
	"./girl with dora.jpg": 98863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86819;